// extracted by mini-css-extract-plugin
export var background = "_53-0";
export var container = "_53-1";
export var contentItem = "_53-7";
export var extendedWarranty = "_53-5";
export var link = "_53-d";
export var modal = "_53-b";
export var modalCloseButton = "_53-9";
export var modalContent = "_53-3";
export var modalContentMain = "_53-6";
export var modalImageLogo = "_53-8";
export var modalLogo = "_53-a";
export var modalSideImage = "_53-4";
export var preview = "_53-c";
export var redoModal = "_53-2";